@if (currencies$ | async; as currencies) {
  @if (!!currencies?.length) {
    <div class="px-3 py-2">
      <label class="form-label small mb-1" for="currency-select" i18n>Currency</label>
      @if (currencies?.length === 1) {
        <span class="d-block text-nowrap">{{ currencies[0].description }}</span>
      } @else {
        <select
          id="currency-select"
          class="form-select form-select-sm"
          [(ngModel)]="currencySelectService.currentCurrency"
          [ngModelOptions]="{ standalone: true }"
          (change)="setCurrency($event)"
        >
          @for (currency of currencies$ | async; track currency.id) {
            <option value="{{ currency.id }}" [selected]="currencySelectService.currentCurrency === currency.id">
              {{ currency.description }}
            </option>
          }
        </select>
      }
    </div>
  }
}
